
import { defineComponent, reactive, toRefs, watch } from 'vue'
import { countAd } from '@/http/api'
export default defineComponent({
  name: 'switchBtn',
  components: {},
  props: {
    activeColor: {
      type: String,
    },
    switchVal:{
      type:Number,
      default:0,
    }
  },
  setup(props,{emit}) {
    const data = reactive({
      checked : false
    })
    
    const methods = {
      handleSwitch(val:boolean){
        countAd(7443)
        emit('changeSwith',val)
      }
    }
    watch(
      () => props.switchVal,
      (nVal) => {
        data.checked = nVal === 1 ? true : false
      },
      {
      deep:true,
      immediate:true
      }
    )
    return {
      ...toRefs(data),
      ...methods
    }
  },
})
